export default __webpack_public_path__ + "static/media/ABYB.64428176.png";